import { render, staticRenderFns } from "./MysqlDatabase.vue?vue&type=template&id=a868d6ec&"
import script from "./MysqlDatabase.vue?vue&type=script&lang=js&"
export * from "./MysqlDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a868d6ec')) {
      api.createRecord('a868d6ec', component.options)
    } else {
      api.reload('a868d6ec', component.options)
    }
    module.hot.accept("./MysqlDatabase.vue?vue&type=template&id=a868d6ec&", function () {
      api.rerender('a868d6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/database/MysqlDatabase.vue"
export default component.exports